<template>
  <div>
    <SidebarSearch @submit="submitForm" @clear="clearForm">
      <SearchCollapse :expanded="true" title="Geral">
        <NxInput
        name="nome"
        type="text"
        label="Nome da Campanha:"
        placeholder="Digite o nome"
        @update:value="handleInputUpdate('nome', $event)"
        ></NxInput>
        <NxSelectCampanhaCanal @update:value="handleSelectUpdate('plataforma', $event)" />
        <NxSelectCampanhaSituacao @update:value="handleSelectUpdate('situacao', $event)" />
      </SearchCollapse>
    </SidebarSearch>
  </div>
</template>

<script>
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import { NxSelectCampanhaCanal, NxSelectCampanhaSituacao } from '@/components/nexum/components/custom-selects/index.js'

export default {
  name: 'SidebarListaCampanha',
  components: { SidebarSearch, SearchCollapse, NxSelectCampanhaCanal, NxSelectCampanhaSituacao },
  data () {
    return {
      // Form data devem seguir as nomenclaturas esperadas pelo backend
      form: {
        nome: null,
        plataforma: null,
        situacao: null
      }
    }
  },
  methods: {
    submitForm () {
      this.$nextTick(() => {
        this.$emit('search', this.form)
      })
    },
    clearForm () {
      this.$root.$emit('clearForm')
      this.$nextTick(() => {
        this.submitForm()
      })
    },
    clearField (field) {
      this.form[field] = null
    },
    handleSelectUpdate (fieldName, selectedValue) {
      // If input comes as a string or a number
      if (typeof selectedValue === 'string' || typeof selectedValue === 'number') {
        this.form[fieldName] = selectedValue
        return
      }
      // If to clear multiple select
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }
      // If to clear single select and update both types
      if (selectedValue) {
        this.form[fieldName] = Array.isArray(selectedValue) ? selectedValue.map(v => v.value) : selectedValue.value
      } else {
        this.clearField(fieldName)
      }
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      if (inputedValue) {
        this.form[fieldName] = clean ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '') : inputedValue
      } else {
        this.clearField(fieldName)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/campaign/components/search/SidebarListaCampanha.vue